export const dateRange = 7;
export const dateFormat = "dd-MMM-yyyy HH:mm:ss";
export const dateFormatNoTime = "dd-MMM-yyyy";
